import type { Ride } from '@thrasher/shared';

/** Simple line icons for each ride. */
export function RideIcon({ ride, size = 28 }: { ride: Ride; size?: number }): React.JSX.Element {
  if (ride === 'skateboard') {
    return (
      <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
        <path
          d="M4 26 Q8 20 14 22 L34 22 Q40 20 44 26"
          fill="none"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <circle cx="14" cy="32" r="4" fill="currentColor" />
        <circle cx="34" cy="32" r="4" fill="currentColor" />
      </svg>
    );
  }
  if (ride === 'bmx') {
    return (
      <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
        <circle cx="11" cy="32" r="8" fill="none" stroke="currentColor" strokeWidth="3.5" />
        <circle cx="37" cy="32" r="8" fill="none" stroke="currentColor" strokeWidth="3.5" />
        <path
          d="M11 32 L20 20 L32 20 L37 32 M20 20 L24 32 L32 20 M30 12 L34 12 M32 12 L32 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.5"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
      <path
        d="M14 8 L24 8 L26 26 L40 28 Q42 30 40 32 L10 32 L10 20 Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinejoin="round"
      />
      {[14, 22, 30, 38].map((x) => (
        <circle key={x} cx={x - 1} cy="38" r="3.5" fill="currentColor" />
      ))}
    </svg>
  );
}
